import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { Adal4Service } from 'adal-angular4';
import { adal } from 'adal-angular';
import { isDevMode, enableProdMode } from '@angular/core';




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  
})
export class AppComponent implements OnInit{
   
    config: adal.Config;
    //{                           
    //     tenant: 'valiaweb.net.br',                      
    //     clientId: '20c23c49-707b-428d-b74d-7f587348a142' ,
    //     postLogoutRedirectUri: `${window.location.origin}/home` // 'http://localhost:15188/home'
    // }
    
    constructor(private service: Adal4Service) {                  
      this.configAdal("/api/initadal", service);         
    }


    ngOnInit() {
        
    }



    configAdal(url, servicoadal : Adal4Service)
    {
        var objResult;
        var rawFile = new XMLHttpRequest();
        rawFile.open("GET", url, false);
        rawFile.onreadystatechange = function ()
        {
            if(rawFile.readyState === 4)
            {
                if(rawFile.status === 200 || rawFile.status == 0)
                {
                    var allText = rawFile.responseText;   
                    //alert(allText);     
                      
                    objResult = JSON.parse(allText);
                    
                }
            }
        }
        rawFile.send(null);
        //console.log("dentro do método configAdal", objResult);       
        this.config = objResult;
        
        servicoadal.init(this.config); 

      
    }
}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/app.component.ts